<template lang="pug">
  header.header.wrapper-p
    a.header__logo(
      href=`https://www.euromobile.ru/`
      target=`_blank`
    )
      svg(xmlns=`http://www.w3.org/2000/svg`)
        use(:href="$setSvgHref(`img/sprite.svg#i-logo`)")

    button.header__mobile-btn.only-mobile(
      type=`button`
      @click="onMobileBtnClick"
    )
      span
      span
      span
      span

    nav.header__nav.header__nav-left.nav
      a.header__logo-min.nav__item.t-ttu.t-tdn(
        href=`https://em-engin.ru/`
      ) ЕМ.Т
      span.header__logo-min.nav__item.t-ttu.t-tdn ЦБК
      a.header__logo-min.nav__item.t-ttu.t-tdn(
        href=`https://mrm.em-engin.ru/`
      ) ПАК МРМ

    nav.header__nav.header__nav-right.nav
      a.nav__item.t-ttu.t-tdn(
        href=`#`
        data-target=`features`
        @click.prevent="onNavItemClick"
      ) Преимущества
      a.nav__item.t-ttu.t-tdn(
        href=`#`
        data-target=`characteristics`
        @click.prevent="onNavItemClick"
      ) Характеристики
      a.nav__item.nav__item--btn.t-ttu.t-tdn(
        @click.prevent.stop="modalOpen"
        href=`#`
      ) Тестирование
</template>

<script>
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import smoothScroll from '@/helpers/smooth-scroll'

export default {
  data () {
    return {
    }
  },
  mounted () {
    const setHeaderHeight = () => {
      this.$store.dispatch('setHeaderHeight', this.$el.offsetHeight)

      document.documentElement.style.setProperty(
        `--header-height`,
        `${this.$el.offsetHeight}px`
      )
    }

    setHeaderHeight()

    window.addEventListener(`resize`, setHeaderHeight)
  },
  methods: {
    onNavItemClick (evt) {
      const targetId = evt.target.dataset.target
      const target = document.querySelector(`[data-id=${targetId}]`)
      const offset = target.offsetTop

      this.$el.classList.remove(`opened`)
      clearAllBodyScrollLocks()

      smoothScroll(offset)
    },
    modalOpen () {
      this.$store.dispatch(`showModal`, {
        title: `Тестирование`,
        visible: true
      })
    },
    onMobileBtnClick () {
      if (!this.$el.classList.contains(`opened`)) {
        disableBodyScroll(this.$el)
      } else {
        clearAllBodyScrollLocks()
      }

      this.$el.classList.toggle(`opened`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 3rem;
    padding-bottom: 3rem;
    background-color: transparent;
    transition: $trs;

    &.scroll {
      background-color: $white;
    }

    &.down {
      opacity: 0;
      pointer-events: none;
    }

    &.up {
      opacity: 1;
      pointer-events: all;
    }

    @include respond-max(tablet) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      &.opened {
        min-height: 100vh;
        background-color: $white;
      }
    }
  }

  .header__logo {
    display: block;
    width: 17.25rem;
    height: 3rem;
    @include respond-max(tablet) {
      width: 14rem;
    }

    svg {
      width: 100%;
      height: 100%;
      color: $white;
      transition: $trs;

      .header.scroll &,
      .header.opened & {
        color: $d-blue;
      }
    }

    &:hover {
      svg {
        opacity: 0.8;
      }
    }
  }

  .header__mobile-btn {
    position: absolute;
    top: 3rem;
    right: calc(#{$offset-mobile} - 1rem);
    width: calc(2rem + 18px);
    height: calc(2rem + 15px);
    margin-left: auto;
    padding: 1rem;
    font-size: 0;
    background-color: transparent;
    border: 0;
    cursor: pointer;

    span {
      position: absolute;
      right: 1rem;
      width: 18px;
      height: 3px;
      background: $white;
      opacity: 1;
      transform: rotate(0deg);
      transition: 0.25s ease-in-out;

      .header.scroll &,
      .header.opened & {
        background-color: $d-blue;
      }

      &:nth-of-type(1) {
        top: 1rem;
      }

      &:nth-of-type(2),
      &:nth-of-type(3) {
        top: calc(1rem + 6px);
      }

      &:nth-of-type(4) {
        top: calc(1rem + 12px);
        width: 12px;
      }
    }

    .header.opened & {
      span {
        &:nth-of-type(1),
        &:nth-of-type(4) {
          top: calc(1rem + 6px);
          right: 50%;
          width: 0;
          opacity: 0;
        }

        &:nth-of-type(2) {
          transform: rotate(45deg);
        }

        &:nth-of-type(3) {
          transform: rotate(-45deg);
        }
      }
    }
  }
  .header__nav-left {
    margin-right: auto;
    column-gap: 48px;
    @include respond-max(desktop-sm) {
      column-gap: 24px;
    }
    @include respond-max(tablet) {
      column-gap: 16px;
    }

    .nav__item {
      margin-right: 0;
    }

    @include respond-max(tablet) {
      border-bottom: 2px solid $d-blue;
    }
  }

  .nav {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-left: 2.92vw;
    transition: $trs;

    @include respond-max(tablet) {
      overflow: hidden;
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      height: 0;
      margin-left: 0;
      opacity: 0;
      pointer-events: none;
      transition-property: opacity;

      .header.opened & {
        height: auto;
        margin-top: 2rem;
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  .nav__item {
    width: fit-content;
    @include font('m');
    position: relative;
    margin-right: 2.92vw;
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: 0.875rem;
    line-height: 1.2;
    letter-spacing: 0.06em;
    color: $white;
    transition: $trs;

    &:last-of-type {
      margin-right: 0;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 0;
      height: 2px;
      background-color: $blue;
      transition: $trs;
    }

    &--btn {
      padding: 1.375rem 2rem;
      border-radius: 2rem;
      border: 2px solid $blue;

      &::after {
        display: none;
      }

      &:hover {
        background-color: $blue;
      }
    }

    &:hover, &:is(span) {
      &::after {
        left: 0;
        width: 100%;
      }
    }

    .header.scroll & {
      color: $black;

      &--btn:hover {
        color: $white;
      }
    }

    @include respond-max(desktop-sm) {
      margin-right: 24px;
    }

    @include respond-max(tablet) {
      margin-bottom: 1rem;
      margin-right: 0;
      color: $d-blue;

      &--btn {
        align-self: flex-start;
      }

      &:not(&::after) {
        display: none;
      }

      &::after {
        height: 1px;
        background-color: $d-blue;
      }
    }
  }
</style>
